import React, {useEffect, useState} from "react";
import Button from "@material-ui/core/Button";
import { useSelector } from "react-redux";
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  withStyles
} from "@material-ui/core";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import Axios from "axios";
import { API } from "../../../../utilities/api.config";
import { downloadBlob } from "../../../../utilities/download-blob";
import ErrorMessage from "../../../../components/UI/ErrorMessage";

const styles = (theme) => ({
  mainButton: {
    marginLeft: 20,
  }
});

const DownloadReport = ({classes, householdId}) => {
  const [modalOpened, setModalOpened] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [downloading, setDownloading] = useState(false);
  const [availableReports, setAvailableReports] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const appState = useSelector((store) => store.app);

  useEffect(() => {
    if (modalOpened === true) {
      Axios
        .get(`${API.GET_HOUSEHOLD_REPORTS_BY_ID}/${householdId}`)
        .then(({ data }) => {
          setAvailableReports(data.reports)
        })
        .catch(e => {
          setAvailableReports([])
        });
    } else {
      setSelectedReport(null);
    }
  }, [modalOpened])

  const downloadReport = () => {
    setDownloading(true);
    const file = availableReports.find(r => r.key === selectedReport);
    Axios
      .post(`${API.DOWNLOAD_REPORT}`, {
        householdId,
        file
      }, {responseType: 'blob'})
      .then(async (response) => {
        if (response) {
          await downloadBlob(
            response.data,
            `${file.description} for household ${householdId}.pdf`
          );
          setErrorMessage(null);
          setDownloading(false);
        }
      })
      .catch(e => {
        setErrorMessage('Cy has encountered some issue downloading the report. Please try again')
        setDownloading(false);
      });
  }

  if (!appState.reportingEnabled) {
    return null
  }

  return (
    <React.Fragment>
      <Button
        variant="contained"
        color="primary"
        className={`${classes.mainButton}`}
        onClick={() => setModalOpened(true)}
        data-cy="household.downloadReport"
      >
        Download Report
      </Button>
      {
        !!availableReports &&
        <Dialog
          open={modalOpened}
          keepMounted
          onClose={() => this.handleClose()}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            Download Report
          </DialogTitle>
          <DialogContent>
            {
              availableReports.length === 0 &&
              <DialogContentText id="alert-dialog-slide-description">
                This household currently doesn't have any reports to download. Please check back later.
              </DialogContentText>
            }
            {
              availableReports.length > 0 &&
              <React.Fragment>
                <DialogContentText id="alert-dialog-slide-description">
                  Please select which report you want to download.
                  {
                    !!errorMessage &&
                    <ErrorMessage>{errorMessage}</ErrorMessage>
                  }
                </DialogContentText>
                <RadioGroup
                  value={selectedReport}
                  onChange={(e) => setSelectedReport(e.target.value)}
                >
                  {
                    availableReports.map((report) =>
                      <FormControlLabel
                        key={report.key}
                        value={report.key}
                        control={<Radio size={"small"} color={"primary"}/>}
                        label={report.description}
                      />
                    )
                  }
                </RadioGroup>
              </React.Fragment>
            }
          </DialogContent>
          <DialogActions style={{ paddingRight: "1em", paddingBottom: "1em" }}>
            <Button
              onClick={() => setModalOpened(false)}
              size="small"
            >
              Close
            </Button>
            {
              availableReports.length > 0 &&
              <Button
                className={classes.btn}
                onClick={downloadReport}
                size="small"
                variant={"contained"}
                color={"primary"}
                disabled={!selectedReport || downloading}
              >
                {downloading && <CircularProgress size={16} />}
                &nbsp;
                Download
              </Button>
            }
          </DialogActions>
        </Dialog>
      }
    </React.Fragment>
  )
}

export default withStyles(styles)(DownloadReport);



// WEBPACK FOOTER //
// ./src/containers/HouseholdDetail/components/DownloadReport/index.jsx